// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-overlay {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 8000;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 30px;
  }
  
  .loading-spinner {
    border: 6px solid #f3f3f3;
    border-top: 6px solid #11047A;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 1s linear infinite;
    
  }

  .loading-text {
    font-size: 16px;
    color: #11047A;
    font-weight: bold;
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .assembly-line-container {
    width: 100%;
    height: 400px; /* Adjust as needed */
    overflow: hidden;
  }
  
  .assembly-line {
    position: relative;
  }
  
  .assembly-line-item {
    position: absolute;
    width: 50px; /* Adjust as needed */
    height: 50px; /* Adjust as needed */
    background-color: #3498db; /* Adjust as needed */
    animation: move-assembly-line 4s linear infinite;
  }
  
  @keyframes move-assembly-line {
    0% {
      top: -50px;
    }
    100% {
      top: 100%;
    }
  }
  
  
  
  @media (max-width: 480px) {
    .loading-overlay {
      position: relative;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.8);
      z-index: 8000;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    
    .loading-spinner {
      border: 6px solid #f3f3f3;
      border-top: 6px solid #11047A;
      border-radius: 50%;
      width: 60px;
      height: 60px;
      animation: spin 1s linear infinite;
    }
  
    .loading-text {
      font-size: 16px;
      margin-top: 10px;
      color: #11047A;
      font-weight: bold;
    }
  }`, "",{"version":3,"sources":["webpack://./src/css/main.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;;EAEpC;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,WAAW;IACX,aAAa,EAAE,qBAAqB;IACpC,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW,EAAE,qBAAqB;IAClC,YAAY,EAAE,qBAAqB;IACnC,yBAAyB,EAAE,qBAAqB;IAChD,gDAAgD;EAClD;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,SAAS;IACX;EACF;;;;EAIA;IACE;MACE,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,WAAW;MACX,YAAY;MACZ,0CAA0C;MAC1C,aAAa;MACb,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,sBAAsB;IACxB;;IAEA;MACE,yBAAyB;MACzB,6BAA6B;MAC7B,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,kCAAkC;IACpC;;IAEA;MACE,eAAe;MACf,gBAAgB;MAChB,cAAc;MACd,iBAAiB;IACnB;EACF","sourcesContent":[".loading-overlay {\n    position: relative;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.8);\n    z-index: 8000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    border-radius: 30px;\n  }\n  \n  .loading-spinner {\n    border: 6px solid #f3f3f3;\n    border-top: 6px solid #11047A;\n    border-radius: 50%;\n    width: 60px;\n    height: 60px;\n    animation: spin 1s linear infinite;\n    \n  }\n\n  .loading-text {\n    font-size: 16px;\n    color: #11047A;\n    font-weight: bold;\n  }\n  \n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  .assembly-line-container {\n    width: 100%;\n    height: 400px; /* Adjust as needed */\n    overflow: hidden;\n  }\n  \n  .assembly-line {\n    position: relative;\n  }\n  \n  .assembly-line-item {\n    position: absolute;\n    width: 50px; /* Adjust as needed */\n    height: 50px; /* Adjust as needed */\n    background-color: #3498db; /* Adjust as needed */\n    animation: move-assembly-line 4s linear infinite;\n  }\n  \n  @keyframes move-assembly-line {\n    0% {\n      top: -50px;\n    }\n    100% {\n      top: 100%;\n    }\n  }\n  \n  \n  \n  @media (max-width: 480px) {\n    .loading-overlay {\n      position: relative;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background-color: rgba(255, 255, 255, 0.8);\n      z-index: 8000;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: column;\n    }\n    \n    .loading-spinner {\n      border: 6px solid #f3f3f3;\n      border-top: 6px solid #11047A;\n      border-radius: 50%;\n      width: 60px;\n      height: 60px;\n      animation: spin 1s linear infinite;\n    }\n  \n    .loading-text {\n      font-size: 16px;\n      margin-top: 10px;\n      color: #11047A;\n      font-weight: bold;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
